import DStateSecCommissionsPage from './DStateSecCommissionsPage'

export default DStateSecCommissionsPage
